import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";
import {Prodotto} from "./Prodotto";
import {STATO_ORDINE} from "./Ordine";

@Injectable({
   providedIn: 'root'
})
export class ProdottoVarianteFactory {

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService) {
   }

   async getProductVariants(prodotto_id, vendorSlug=null):Promise<ProdottoVariante[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/prodotti/${prodotto_id}/productvariants` : `/api/prodotti/${prodotto_id}/productvariants`
      return new Promise<ProdottoVariante[]>((resolve, reject) => {
         this.serverSrv.getAll(ProdottoVariante, url).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async getPVariant(prodotto_id, pVariantId, vendorSlug=null):Promise<ProdottoVariante> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/prodotti/${prodotto_id}/productvariants/${pVariantId}` : `/api/prodotti/${prodotto_id}/productvariants/${pVariantId}`
      return new Promise<ProdottoVariante>((resolve, reject) => {
         this.serverSrv.get(ProdottoVariante, url).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async postProdottoVariante(prodottoId, data, vendorSlug=null):Promise<ProdottoVariante[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/prodotti/${prodottoId}/productvariants` : `/api/prodotti/${prodottoId}/productvariants`
      return new Promise<ProdottoVariante[]>((resolve, reject) => {
         this.serverSrv.post(url, data, ProdottoVariante).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async putProdottoVariante(prodottoId, productVariantId, data, vendorSlug=null):Promise<ProdottoVariante> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/prodotti/${prodottoId}/productvariants/${productVariantId}` : `/api/prodotti/${prodottoId}/productvariants/${productVariantId}`
      // let url = `/api/esercizi/${vendorSlug}/prodotti/${prodottoId}/productvariants/${productVariantId}`
      return new Promise<ProdottoVariante>((resolve, reject) => {
         ServerService.instance.put(url, data, ProdottoVariante).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async deleteProdottoVariante(prodottoId, productVariantId, vendorSlug=null):Promise<ProdottoVariante> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/prodotti/${prodottoId}/productvariants/${productVariantId}` : `/api/prodotti/${prodottoId}/productvariants/${productVariantId}`
      return new Promise<ProdottoVariante>((resolve, reject) => {
         ServerService.instance.delete( url, {}, ProdottoVariante).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async approvaProdottoVariante(prodottoId, varianteId) {
      return new Promise<ProdottoVariante[]>((resolve, reject) => {
         ServerService.instance.put( `/api/prodotti/${prodottoId}/productvariants/${varianteId}/approva`, {}, ProdottoVariante).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }
}

export class ProdottoVarianteData {
   id?: number;
   codice?: string;
   colore?: number;
   qta_tot?: number;
   prezzo_min?: number;
   prezzo_max?: number;
   colore_nome?: string;
   colore_str?: string;
   desc_colore?: string;
   image?: string;
   img_variant?: string;
   prodotto?:any;
   p_acquisto_listino_default?: number;
   p_vendita_listino_default?: number;
}

export class ProdottoVariante {

   data:ProdottoVarianteData = {}

   constructor(data:ProdottoVarianteData) {
      // assegno al mio oggetto data (è un json)
      if(!data) data = {}
      Object.assign(this.data, data)

      if(!data.prodotto)
         this.data.prodotto = new Prodotto({});
      else
         this.data.prodotto = new Prodotto(data.prodotto);
   }

   public static HeaderFilterStatoData = [{
      text: "Attivo",
      value: true
   }, {
      text: "Non attivo",
      value: false
   }];

   // public static BASE_URL(path=null, queryParams={}):string{
   // let url:UrlObj = new UrlObj(`/api/colori`, queryParams);
   // if(path) url.url += path;
   // return url.toString()
   // }



}
